import React, { useState, useEffect } from "react"
// import { useStaticQuery, graphql, Link, withPrefix } from "gatsby"
import { useStaticQuery, graphql, Link } from "gatsby"

import { Twirl as Hamburger } from 'hamburger-react'

import Search from "./search"

import logo from "../images/logo.svg"

import sidebarStyles from "./sidebar.module.css"
import { Fragment } from "react"


export default function Sidebar({submenuDataSourceName, postLink}) {

    // console.log("RENDER SIDEBAR")
    // console.log("submenuDataSourceName: ", submenuDataSourceName)

    // console.log("window.history in Sidebar.js ", window.history.state)
    // let activePageName = null
    // // if window.history.state.id passed, we must open the branch
    // if(typeof window !== `undefined` && window.history.state && window.history.state.pageName){
    //     //console.log("ID: ", window.history.state.id)
    //     activePageName = window.history.state.pageName
    // }  

    // console.log("activePageName: ", activePageName)

    const [isOpen, setOpen] = useState(false)

    // handle situation when we need to close mobile menu when clicked outside of hamburger
    useEffect(() => {
        const clickHandler = ({ target }) => {

            if(target.closest('.hamburger-react') || !isOpen || (target.getAttribute("id") === 'search_btn') || target.closest("#search")){
                return
            }

            // close mobile menu
            setOpen(false)
        }

        document.addEventListener("click", clickHandler)

        // these functions clean up the event listeners
        return () => document.removeEventListener("click", clickHandler)
    })      

    const data = useStaticQuery(graphql`
        query {
            allMdx (sort: { fields: [frontmatter___weight], order: DESC }) {
                totalCount
                edges {
                    node {
                        id
                        frontmatter {
                            post_title
                            dir
                            weight
                        }
                        fields {
                            slug
                        }    
                        tableOfContents(maxDepth: 2)                    
                    }
                }              
            }
            siteSearchIndex {
                index
            }               
            allApiJson{
                edges {
                  node {
                    name
                    content {
                      title
                      menu_title
                      method
                      version
                      name
                      description
                      message{
                          type
                          text
                      }
                      request_description
                      code {
                        name
                        example
                      }
                      method_arguments{
                        order
                        name
                        data_type
                        short_description
                        required
                        description                          
                      }          
                      return_object{
                          name
                          order
                          description
                          short_description
                      }                                
                      response
                      response_description
                      input_objects{
                          name
                          description
                          short_description                          
                          attributes{
                            name
                            short_description
                            order
                            data_type
                            required
                            description                         
                            attributes{
                                name
                                order
                                required
                                data_type
                                short_description
                                description
                                message{
                                    type
                                    text
                                }                                  
                                attributes{
                                    name
                                    order
                                    required
                                    data_type
                                    short_description
                                    description                                 
                                    attributes{
                                        name
                                        order
                                        required
                                        data_type
                                        short_description
                                        description                                        
                                    }                                         
                                }                                  
                            }                              
                          }
                      }
                      output_objects{
                          name
                          description
                          data_type                       
                          short_description
                          example                           
                          attributes{
                            name
                            order
                            data_type
                            short_description
                            description                                
                            attributes{
                                name
                                order
                                data_type
                                short_description
                                description                                                                     
                            }                               
                          }
                      }                     
                    }
                  }
                }
              }                                                  
        }
    `)


   let extraSubmenus = [
       {
            submenu_items: false,
            submenuDataSourceName: 'transcoding'
       },

       {
            submenu_items: false,
            submenuDataSourceName: 'streaming'
       },       
   ]

   extraSubmenus.forEach(({submenu_items, submenuDataSourceName}, index) => {
    let nodeJSON = data.allApiJson.edges.filter( ({node}) => node.name === submenuDataSourceName)[0] 
    let contentJSON = nodeJSON.node.content
    let linkAndId = contentJSON.map(({menu_title, title}) => {
        return {
            text: menu_title,
            id: title.toLowerCase().split(' ').join('-')
        }
    })

    let apiReferenceTranscodingNode = data.allMdx.edges.filter(({node}) => node.fields.slug === `/api-reference/${submenuDataSourceName}/`)[0].node

    if(apiReferenceTranscodingNode ){
        let { items } = apiReferenceTranscodingNode.tableOfContents
        let pageLinks = []
        if(items){
            pageLinks = items
        }
        pageLinks.forEach(link => {
            linkAndId.push({
                text: link.title,
                id: link.url.substring(1) // remove # as it will be added later
            })
        })
    }        

    extraSubmenus[index].submenu_items = linkAndId.map( (item, index) => {
        
        return(
            <li key={index}>
                <a
                    data-menu-item='submenu'
                    href={`/api-reference/${submenuDataSourceName}/#${item.id}`}
                >
                    {item.text}
                </a>
            </li>
        )
    })  


   })

   //console.log("extraSubmenus: ", extraSubmenus)


    // check URL against List of URL, it is unique if we find it only once
    function isUrlUniqueInUrlsList(url, urlList){
        let counter = -1
        urlList.forEach(item => {
            if(item.includes(url)){
                counter++
            }
        })
        return !counter
    }    

    function findAllSectionPostsInList(section, nodes){
        // posts will have matching urls /Tutorials/Storage/Qencode-Storage/  
        let posts = nodes.map(( {url, name} ) => {
            return {
                dir: url,
                name
            }
        })
        posts = posts.filter( ({ dir }) => dir.includes(section) && dir !== section)   
        
        // replace  "/Tutorials/Storage/Third-Party-Storage/microsoft-azure/" with "microsoft-azure"
        posts = posts.map(({ dir, name }) => {
            dir = dir.slice(1, -1).split('/')[3]
            return {
                dir: dir,
                name
            }
        })
            
        return posts
    }      


    let menu_from_data = []   

    let urlList = []

    let nodes = data.allMdx.edges.map( ({ node }) => {
        // console.log(node.fields.slug)
        urlList.push(node.fields.slug)
        return {
            url: node.fields.slug,
            name: node.frontmatter.dir
        } 
    })      

    // add top level Docs first
    nodes.forEach( ({ url, name }) => {
        let urlArray = url.slice(1, -1).split('/')
        if(urlArray.length === 1){
            menu_from_data.push({
                "name": name,
                "dir": urlArray[0],
                "categories":[]             
            })
        }
    })   
    
    // add categories
    nodes.forEach( ({ url, name }) => {
        let urlArray = url.slice(1, -1).split('/')
        if(urlArray.length === 2){
            // find relevant Doc and add categories in there 
            menu_from_data.forEach(({ dir }, index) => {
                if(urlArray[0] === dir){
                    menu_from_data[index].categories.push({
                        "name": name,
                        "dir": urlArray[1],
                        "sections":[],
                        "posts":[]
                    })
                }
                
            })
        }
    })      


    // add sections[] and posts[] inside categories
    nodes.forEach( ({ url, name }) => {
        let urlArray = url.slice(1, -1).split('/')
        if(urlArray.length === 3){
            // if this part of URL is unique in URL list, this is POST
            // otherwise this is sectio
            // if URL is unique in the URLs list, push it to posts array of their category
 
            if(isUrlUniqueInUrlsList(url, urlList)){
                // find relevant Doc
                menu_from_data.forEach(({ dir }, index) => {
                    if(urlArray[0] === dir){
                        // find relevant category
                        menu_from_data[index].categories.forEach((category) => {
                            if(category.dir === urlArray[1]){
                                category.sections.push({
                                    "name": name,
                                    "dir": urlArray[2],
                                    posts:[]
                                })
                            }
                        })
                    }                     
                })      
            } else{
                // find all posts relvant to this section and add them also      
                let posts = []
                posts = findAllSectionPostsInList(url, nodes)

                // this is a name of section, push it to the array of sections
                // find relevant Doc
                menu_from_data.forEach(({ dir }, index) => {
                    if(urlArray[0] === dir){
                        // find relevant category
                        menu_from_data[index].categories.forEach((category) => {
                            if(category.dir === urlArray[1]){          
                                category.sections.push({
                                    "name": name,
                                    "dir": urlArray[2],
                                    posts: posts
                                })                                
                            }
                        })
                    }                     
                }) 
            }    
  
        }
    })    

    

    // remove index page from top level docs
    menu_from_data = menu_from_data.filter(({ dir }) => dir !=='');

    // BUILDING UI
    // menu is sorted by 'weight' from md file frontmatter by Graphql request
    const menu = menu_from_data
    // console.log("menu", menu);
    
    // TODO
    // need to associate top level articles with images

    // <img src={`/gatsby-docs/images/docs/${item.dir}.svg`} alt={item.dir} />
    // <img src="/images/docs/tutorials.svg" alt="Tutorials" />

    // const prefixedURL = getPrefixedPath("/images/docs/tutorials.svg")
    // console.log("prefixedURL: ", prefixedURL)

    // const prefixedURL = withPrefix(`/images/docs/tutorials.svg`)
    // console.log("prefixedURL: ", prefixedURL)

    const bookmark = (
        <div className={sidebarStyles.bookmark}>          
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512.02"><defs></defs><path d="M362.68,0H149.34A53.33,53.33,0,0,0,96,53.33v448a10.67,10.67,0,0,0,18.22,7.56L256,367.08,397.79,508.86A10.67,10.67,0,0,0,416,501.33v-448A53.33,53.33,0,0,0,362.68,0Z" transform="translate(-96.01 0)"/></svg>
        </div>
    )
   

    //let menu_items = menu.map( (item, index) => 
    // let menu_items = menu_from_data.map( (item, index) => 
    let menu_items = menu.map( (item, index) => 
        <li key={index}>
            <Link 
                to={`/${item.dir}/`}
                // className={sidebarStyles.doc}
                activeClassName={sidebarStyles.active}
      
                className = {
                    (`/${item.dir}/` === "/api-reference/transcoding/")  && (postLink === "/api-reference/transcoding/")
                    ? `${sidebarStyles.doc} ${sidebarStyles.active}`
                    //: sidebarStyles.doc // don't open menu items that are not active
                    : `${sidebarStyles.doc} ${sidebarStyles.active}` // this will effectivly open all 1st level menu items
                }                   
                

                partiallyActive={true}
            >
                {/* <img src={withPrefix(`/images/docs/${item.dir}.svg`)} alt={item.dir} /> */}
                {bookmark}
                <div>{item.name}</div>
            </Link>      


            <ul className={`${sidebarStyles.section} ${sidebarStyles.categories}`}>
                {item.categories.map((category, index) => (
                    <li key={index}>
                        <Link 
                            // to={`/${item.dir}/${category.dir}/`} // as all is open, disable it as link
                            activeClassName={sidebarStyles.active}
                            
                            className = {`${sidebarStyles.category} ${sidebarStyles.active}`} // open all second level menu items

                            partiallyActive={true}
                        >
                            {category.name}
                        </Link>   


                        <ul className={`${sidebarStyles.section} ${sidebarStyles.sections}`}>   
                            
                            {/* {
                                extraSubmenus.map((submenu, index) => 
                                    <Fragment key={index}>
                                        {
                                            submenuDataSourceName && submenu.submenu_items.length > 0 && `/${item.dir}/${category.dir}/` === `/api-reference/${submenu.submenuDataSourceName}/` && submenu.submenu_items
                                        }
                                    </Fragment>
                                )
                            } */}

{
                                extraSubmenus.map((submenu, index) => 
                                    <Fragment key={index}>
                                        {
                                            `/${item.dir}/${category.dir}/` === `/api-reference/${submenu.submenuDataSourceName}/` && submenu.submenu_items
                                        }
                                    </Fragment>
                                )
                            }                            

                                      
                            {category.sections.map((section, index) => (

                                <li key={index}>
                                    {

                                        section.posts.length > 0
                                        ?
                                        <Link 
                                            to={`/${item.dir}/${category.dir}/${section.dir}/`}
                                            activeClassName={`${sidebarStyles.active} ${sidebarStyles.hasPosts}`}                                         
                                            partiallyActive={true}                                        
                                        >
                                            {section.name}
                                        </Link>       
                                        :
                                        <Link 
                                            to={`/${item.dir}/${category.dir}/${section.dir}/`}
                                            activeClassName={sidebarStyles.active}
                                            partiallyActive={true}                                        
                                        >
                                            {section.name}
                                        </Link>                                                                                  
                                    }

                                    {
                                        section.posts.length > 0 &&

                                        <ul className={`${sidebarStyles.section} ${sidebarStyles.posts}`}>                            
                                            {section.posts.map((post, index) => (
                                                <li key={index}>
                                                    <Link 
                                                        to={`/${item.dir}/${category.dir}/${section.dir}/${post.dir}/`}
                                                        activeClassName={sidebarStyles.active}                                                     
                                                    >
                                                        {post.name}
                                                    </Link>   
                                                </li>
                                            ))}                            
                                        </ul>                                           

                                    }

                                 

                                </li>
                            ))}

                            {/* {category.posts.map((post, index) => (
                                <li key={index} data-weight={post.weight}>
                                    <Link 
                                        to={`/${item.dir}/${category.dir}/${post.dir}/`}
                                        activeClassName={sidebarStyles.active}                                       
                                    >
                                        {post.name}
                                    </Link>   
                                </li>
                            ))}           */}


                        </ul>

                    </li>
                ))}
            </ul>

        </li>        
    )    



    let isInViewport = (elem) => {
        let bounding = elem.getBoundingClientRect();
        return (
            bounding.top >= 0 && bounding.bottom <= (window.innerHeight*0.5 || document.documentElement.clientHeight)
        );
    };    

    useEffect(() => {


        const scrollHandler = () => {

            let allHeaders = document.querySelectorAll('h2')

            let allSubmenuElements = document.querySelectorAll("[data-menu-item='submenu']")

            //console.log("allSubmenuElements: ", allSubmenuElements);


            //console.log("allHeaders: ", allHeaders);

            allHeaders.forEach(title => {

                if (isInViewport(title)){
                    //console.log("title.id: ", title.id);
                    // let allSubmenuElements = document.querySelectorAll("[data-menu-item='submenu']")

                    // console.log("allSubmenuElements: ", allSubmenuElements);

                    //console.log(" allSubmenuElements[0].href ",  allSubmenuElements[0].href)

                    if (allSubmenuElements && allSubmenuElements.length > 0){

                        allSubmenuElements.forEach(element => {
                            element.className = ''
                        })

                        try {

                            // console.log("submenuDataSourceName: ", submenuDataSourceName);
                            // href="/api-reference/streaming/#creating-a-live-stream"

                            // find related menu item
                            //let domElement = [...allSubmenuElements].filter(element => element.href.split('#')[1] === title.id)[0];
                            let domElement = [...allSubmenuElements].filter(element => element.href.endsWith(`${submenuDataSourceName}/#${title.id}`))[0];

                            domElement.className = sidebarStyles.active                            
                            
                        } catch (error) {
                            console.log("error: ", error);
                        }

                        // let domElement = document.querySelector(`[href='#${title.id}']`)

                        // domElement.className = sidebarStyles.active
                    }
                }
            })
            
        }

        if(postLink === '/api-reference/transcoding/' || postLink === '/api-reference/streaming/'){
            //console.log("Add on scroll event listenter")
            document.addEventListener("scroll", scrollHandler)
        }
        
        //document.addEventListener("scroll", scrollHandler)

        // these functions clean up the event listeners
        return () => document.removeEventListener("scroll", scrollHandler)
    }, [postLink, submenuDataSourceName])      


    return (
        <div className={isOpen ? `${sidebarStyles.menu} ${sidebarStyles.mobileOpen}` : sidebarStyles.menu} >
            <div className={sidebarStyles.header}>
                <div className={sidebarStyles.headerTop}>
                    <Link to='/'>
                        <img className={sidebarStyles.logo} src={logo} alt="Qencode" />
                    </Link>  
                    <div className={sidebarStyles.hamburger}>
                        <Hamburger 
                            id='hamburger'
                            toggled={isOpen} toggle={setOpen} 
                            duration={0.1}
                            color="#2b6cf2"
                        />
                    </div>
                </div>
                <div className={sidebarStyles.headerSearch}>
                    <Search searchIndex={data.siteSearchIndex.index} jsonDataSource={data.allApiJson} />       
                </div>                                               
            </div>
            <nav className={sidebarStyles.content}>
                <ul>{menu_items}</ul>
            </nav>
        </div>
    )
}









